/*eslint-disable*/
import React, { Component } from 'react'
import { Form as Formiker, Field as Fieldmik, Formik } from 'formik';
import * as yup from 'yup';
import moment from 'moment'
import { Form as FormUi, Button, Segment, Dropdown } from 'semantic-ui-react'
import { connect } from 'react-redux'
import AddTitleBar from '../titleBar/add_titleBar' 

import EditDocumentTable from './editDocumentTable';


import { selectVehicleId } from '../../redux/actions/formActions'
import { getVehicleList, createDocument, uploadDocument, getDocumentList } from '../../redux/actions/documentActions'
import LoadingPlaceholder from '../placeholderComponent/loadingPlaceholder';
import MyvehicleNumber from '../apiInputComponent/myVehicleNo';


class EditDocument extends Component{
    constructor(props){
        super(props);
        this.state = {
            vehId: ''
        }
    }
    
    componentDidMount(){
        this.props.getVehicleList(this.props.match.params.id);
        this.props.getDocumentList()
    }
 
    onUpload = (values, index) => {
        console.log("OnUpload ====>", values )
        console.log("Form Data: ", values);
        console.log("Form Props: ", this.props);

        const uploadData = {};
        uploadData.vehicleId = values.vehicleId
        uploadData.vehicleNo = values.vehicleNo
        uploadData.docTypeName = this.props.documentList[index].documentTypeName
        uploadData.docId = this.props.documentList[index].docId
        uploadData.docFile = values.docsData[index].fileUpload.base64.split(',')[1]
        this.props.uploadDocument(uploadData)
        console.log("Upload Data", uploadData)
    }   
    
    onSubmit = values => {
        console.log("Form Data: ", values);
        console.log("Form Props: ", this.props);
        const uploadData = []
        values.docsData.map((object, index) => {    
            let temp = {}
            temp.vehicleId = values.vehicleId
            temp.vehicleNo = values.vehicleNo
            temp.docTypeName = object.documentTypeName
            temp.docId =  object.documentTypeId
            temp.docVehicleMapId = values.docsData[index].vehicleDocExpiry.docVehicleMapId ? values.docsData[index].vehicleDocExpiry.docVehicleMapId : 0
            temp.startDate =  object === undefined ? '' : object.vehicleDocExpiry.startDate === '' ? '' : moment(object.vehicleDocExpiry.startDate).format('DD-MM-YYYY')
            temp.expiryDate = object === undefined ? '' : object.vehicleDocExpiry.expiryDate === '' ? '' :  moment(object.vehicleDocExpiry.expiryDate).format('DD-MM-YYYY')
            temp.fileUpload = ''                           
            uploadData[index] = temp
        })
        this.props.createDocument(uploadData)
    }

    render(){

        const { vehicleUpdate, isLoadingUpdate } = this.props


        const newData = (vehicleUpdate) => {

            let addDoc = {
                diffDays: '',
                documentLink: '',
                expiredDoc: '',
                expiryDate: '',
                startDate: '',
            }

            if(!isLoadingUpdate){
                vehicleUpdate.expiryDocumentData && vehicleUpdate.expiryDocumentData.map((object, index) => {
                    if(object.vehicleDocExpiry.length === 0){
                        object.vehicleDocExpiry = addDoc
                    }
                })
                return vehicleUpdate;
            }

            return vehicleUpdate;
        }

        const initialData = newData(vehicleUpdate)


        const initialValues = {
            "vehicleId": vehicleUpdate.vehicleMasterId ? vehicleUpdate.vehicleMasterId : '',
            "vehicleNo": vehicleUpdate.vehicleNumber ? vehicleUpdate.vehicleNumber : '',
            "vehicleType": vehicleUpdate.vehicleType ? vehicleUpdate.vehicle_type.vehicleType : '', 
            "vehicleBranch": vehicleUpdate.branchObj ? vehicleUpdate.branchObj.branchName : '',
            "docsData": initialData.expiryDocumentData 
        }

        
        if(isLoadingUpdate){
            return (
                <React.Fragment>
                    <LoadingPlaceholder />
                </React.Fragment>
            )
        }
        else{
            return (
                <React.Fragment>
                    <AddTitleBar Title="Edit Document" LinkName="/document" />
                    <Formik
                        initialValues={initialValues}
                        onSubmit={this.onSubmit}
                    >
                        
                        {( values ) => (
                            <Formiker className="m-2">
                            <Segment>
                                <div className="ui form">
                                    <FormUi.Group inline>
                                        <FormUi.Field >
                                            <label className="labelName w3-text-blue">Basic Detials</label>
                                        </FormUi.Field>
                                    </FormUi.Group>
                                    <FormUi.Group inline>
                                        <FormUi.Field width={3}>
                                            <label className="labelName">Vehicle Number</label>
                                        </FormUi.Field>
                                        <FormUi.Field width={3}>
                                            <Fieldmik 
                                                autoComplete="off"
                                                name="vehicleId"   
                                                component={MyvehicleNumber}
                                                placeholder="Vehicle No."
                                                value={values.values.vehicleId}
                                                vehicleNoName='vehicleNo'
                                            />
                                        
                                        {console.log(values)}
                                        </FormUi.Field>
                                        <FormUi.Field width={1} />
                                        <FormUi.Field width={3}>
                                            <label className="labelName">Vehicle Type</label>
                                        </FormUi.Field>
                                        <FormUi.Field width={3}>
                                            <Fieldmik 
                                                name="vehicleType" 
                                                placeholder="Type"
                                                autoComplete="off"
                                                readOnly
                                                />
                                        </FormUi.Field>
                                    </FormUi.Group>
                                    <FormUi.Group inline>
                                        <FormUi.Field width={3}>
                                            <label className="labelName">Branch</label>
                                        </FormUi.Field>
                                        <FormUi.Field width={3}>
                                            <Fieldmik 
                                                name="vehicleBranch" 
                                                placeholder="Branch"
                                                autoComplete="off"
                                                readOnly
                                                />
                                        </FormUi.Field>
                                    </FormUi.Group>
                                </div>
                            </Segment>
                            <div className="ui form">
                                <EditDocumentTable onUpload={this.onUpload} />
                            </div>
        
                            <center className="m-3"><Button size="mini" type="submit" primary>Submit</Button></center>
                        </Formiker>
        
                        ) }
                                    
                    </Formik>
                </React.Fragment>
            )
        }
        
    }
    
}


const mapStatetoProps = (state) => ({
    vehicleUpdate: state.getVehicleList.vehicleList.data ? state.getVehicleList.vehicleList.data[0] : '', 
    isLoadingUpdate: state.getVehicleList.isLoading,
    documentList: state.getDocumentList.documentList.resultSet,
})

export default connect(mapStatetoProps, { createDocument, getVehicleList, selectVehicleId, getDocumentList, uploadDocument } )(EditDocument);

